// Styles for LuxurySuites go here.
import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLuxurySuites = styled.div`
  .pill {
    border-radius: 0 !important;
  }

  .vertical-divider {
    box-sizing: border-box;
    height: ${toRem(40)};
    width: ${toRem(1)};
    border-left: ${toRem(1)} dashed rgb(196, 196, 196);
    margin: 0 ${toRem(8)};
  }

  .cards-container {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: ${toRem(24)};
    flex-wrap: wrap;
  }

  .all-filters-container {
    display: block;
    overflow-x: scroll;
    scrollbar-width: none;
  }

  .filter-pill-container {
    width: max-content;
  }

  .pill-collection {
    overflow: unset;
  }

  .pagination {
    .pagination-arrow {
      font-size: ${toRem(16)} !important;
    }
    .pagination-item {
      line-height: 150% !important;
      font-weight: 700;
    }
  }

  .pagination {
    padding-inline-start: 0;
  }
`;
